<template>
  <keep-alive :include="include">
    <router-view v-wechat-title="title" img-set="/favicon.ico" />
  </keep-alive>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  name: 'EmptyLayout',
  computed: {
    ...mapGetters(['pageTitle']),
    title() {
      return this.pageTitle || this.$route.meta.title
    },
    include() {
      const keepAliveList = [
        'Academic',
        'MeetingDetail',
        'AddressList',
        'ShopAddressList',
        'PatientList',
        'ShopSearch',
        'LiveHistory',
        'SpeakerInvite',
        'Help',
        'WebSignUp',
        'KnowledgeRoom',
        'HaveBuy',
        'HaveAttention',
        'SearchKnowledge',
        'PersonalShop',
        'CollectList',
        'OrderAfterSales',
        'SubmitAfterSales',
        'SpeakerRmbAmount',
        'SpeakerGiftDetail',
        ...this.$store.state.keepAlive.list
      ]
      return keepAliveList
    }
  }
}
</script>
